module.exports = __webpack_public_path__ + "media/images/category_icons/fashion-6cd46817f228845ca87ff0d451c15ec6.svg";